const debounce = (fn, wait) => {
	let timer;
	return (...args) => {
		clearTimeout(timer);
		timer = setTimeout(() => fn(...args), wait);
	};
};

document.querySelectorAll('[data-hero-video-wrap]').forEach((wrap) => {
	const isWebKitVideo = typeof document.createElement('video').webkitEnterFullscreen === 'function';

	const nativeVideo = wrap.querySelector('[data-hero-video-native]');
	const safariDesktop = wrap.querySelector('[data-hero-video-safari-desktop]');
	const safariMobile = wrap.querySelector('[data-hero-video-safari-mobile]');

	if (!isWebKitVideo) {
		if (!nativeVideo) return;

		const markReady = () => nativeVideo.classList.add('is-ready');
		if (nativeVideo.readyState >= 2) {
			markReady();
		} else {
			nativeVideo.addEventListener('loadeddata', markReady, { once: true });
		}

		if (!nativeVideo.querySelector('source[data-src]')) return;

		const loadNativeVideo = () => {
			nativeVideo.querySelectorAll('source[data-src]').forEach((source) => {
				source.src = source.dataset.src;
				source.removeAttribute('data-src');
			});
			nativeVideo.load();
			nativeVideo.play();
		};

		if (!nativeVideo.hasAttribute('data-lazy-hero-video') || (window.Shopify && window.Shopify.designMode)) {
			loadNativeVideo();
			return;
		}

		const nativeObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadNativeVideo();
					nativeObserver.unobserve(entry.target);
				}
			});
		}, { rootMargin: '400px' });

		nativeObserver.observe(nativeVideo);
		return;
	}

	wrap.classList.add('is-safari-video');

	const desktopQuery = window.matchMedia('(min-width: 960px)');
	const startedVideos = new WeakSet();

	const activateVideo = (video) => {
		if (!video) return;
		if (!startedVideos.has(video)) {
			startedVideos.add(video);
			video.querySelectorAll('source[data-src]').forEach((source) => {
				source.src = source.dataset.src;
				source.removeAttribute('data-src');
			});
			video.addEventListener('loadeddata', () => video.classList.add('is-ready'), { once: true });
			video.load();
		}
		video.play().catch(() => {});
	};

	const syncActiveVideo = () => {
		const target = desktopQuery.matches ? (safariDesktop || safariMobile) : (safariMobile || safariDesktop);
		const other = target === safariDesktop ? safariMobile : safariDesktop;
		activateVideo(target);
		if (other && startedVideos.has(other)) other.pause();
	};

	const initialVideo = desktopQuery.matches ? (safariDesktop || safariMobile) : (safariMobile || safariDesktop);
	if (!initialVideo) return;

	const start = () => {
		syncActiveVideo();
		window.addEventListener('resize', debounce(syncActiveVideo, 200));
		window.addEventListener('orientationchange', syncActiveVideo);
	};

	if (!initialVideo.hasAttribute('data-lazy-hero-video') || (window.Shopify && window.Shopify.designMode)) {
		start();
		return;
	}

	const safariObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				start();
				safariObserver.unobserve(entry.target);
			}
		});
	}, { rootMargin: '400px' });

	safariObserver.observe(initialVideo);
});

document.querySelectorAll('[data-lazy-hero-video]').forEach((video) => {
	if (video.closest('[data-hero-video-wrap]')) return;

	const initLazyVideo = () => {
		video.querySelectorAll('source[data-src]').forEach((source) => {
			source.src = source.dataset.src;
			source.removeAttribute('data-src');
		});
		video.load();
		video.play();
	};

	if (window.Shopify && window.Shopify.designMode) {
		initLazyVideo();
		return;
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				initLazyVideo();
				observer.unobserve(entry.target);
			}
		});
	}, { rootMargin: '400px' });

	observer.observe(video);
});
